<template>
  <div style="margin-top: 25px">
    <div style="margin-bottom: 25px">
      <ul class="ul-table" v-for="(contract, index) of contractList" :key="`contract-${index}`"
          :class="getRowClassName(contract)">
        <li style="margin-bottom: 20px">
          <div style="width: 100%">
            <div class="inline-block" style="min-width: 115px">
              <div>
                <el-dropdown>
                  <el-button :type="getStatusType(contract.status)" size="mini" style="padding: 10px 15px">
                    {{ getStatusName(contract.status) }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="onChangeStatus(contract.id, CONTRACT_STATUS.DRAFT)">
                      {{ $t('draft') }}
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="onChangeStatus(contract.id, CONTRACT_STATUS.PUBLISHED)">
                      {{ $t('published') }}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
            <div class="inline-block" :class="getTextClassName(contract)" style="max-width: 65%">
              <div class="border-contract-ref-code" :title="contract.refCode">
                {{ contract.refCode }}
              </div>
            </div>
            <div class="inline-block" :class="getTextClassName(contract)">
              <div v-if="isShowInternalNote(contract)" style="line-height: 34px">
                <el-popover :placement="'right'" width="400" trigger="click" style="padding: 0 !important;">
                  <div class="internal-note-popover-header el-card__header">
                    <span>{{ $t('internalNote') }}</span>
                  </div>
                  <div class="internal-note-popover-body">
                    {{ contract.internalNote }}
                  </div>
                  <i class="el-icon-info btn-icon-note" slot="reference"></i>
                </el-popover>
              </div>
            </div>
            <div class="inline-block" style="float: right" :class="getTextClassName(contract)">
              <div class="label-contract-row">
                <div style="text-align: right">Last Update</div>
                <div style="line-height: 10px">{{ dateFormat.long(new Date(contract.updatedAt)) }}</div>
              </div>
            </div>
          </div>
        </li>
        <li :class="getTextClassName(contract)">
          <div style="display: table; width: 100%">
            <div class="row-table">
              <div class="form-contract-data">
                <div class="label-contract-row">Hotel</div>
                <div class="data-contract-row" :title="getHotelName(contract.hotelId)">{{
                    getHotelName(contract.hotelId)
                  }}
                </div>
              </div>
            </div>
            <div class="row-table" style="width: 30%">
              <div class="form-contract-data">
                <div class="label-contract-row">Agent</div>
                <div class="data-contract-row" :title="getAgentName(contract)">{{ getAgentName(contract) }}</div>
                <div>
                  <el-tag v-for="(market, index) in getMarketList(contract.agentId)"
                          :key="index"
                          type="warning"
                          size="mini"
                          style="margin-right: 3px">{{ market.name }}
                  </el-tag>
                </div>
              </div>
            </div>
            <div class="row-table" style="width: 23%">
              <div class="form-contract-data" style="white-space: nowrap">
                <div class="label-contract-row">Contract Valid</div>
                <div class="data-contract-row" :title="getContractValid(contract)">{{
                    getContractValid(contract)
                  }}
                </div>
              </div>
            </div>
            <div class="row-table" style="width: 15%">
              <div class="form-contract-data">
                <div class="label-contract-row">Sales Person</div>
                <div class="data-contract-row" :title="getSalePersonName(contract)">{{
                    getSalePersonName(contract)
                  }}
                </div>
              </div>
            </div>
            <div class="row-table" style="float: right; width: 12%">
              <div style="text-align: right; white-space: nowrap;">
                <div style="float: right">
                  <el-button
                    plain
                    style="border-radius: 4px 0 0 4px; padding: 10px 20px"
                    type="primary"
                    @click="onEditButtonClick(contract)">
                    {{ $t('edit') }}
                  </el-button>
                  <el-dropdown>
                    <el-button type="primary"
                               style="padding: 10px 5px 10px 0; border-radius: 0px 4px 4px 0; margin-left: -1px;" plain>
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown" class="action-list">
                      <el-dropdown-item @click.native="onPreviewButtonClick(contract.id)">
                        {{ $t('preview') }}
                      </el-dropdown-item>
                      <el-dropdown-item @click.native="onOpenPopupSelectDocumentTypeDownload(contract.id)">
                        {{ $t('download') }}
                      </el-dropdown-item>
                      <el-dropdown-item @click.native="onOpenPopupSelectDocumentType(contract.id)">
                        {{ $t('email') }}
                      </el-dropdown-item>
                      <el-dropdown-item @click.native="onSignedDocumentClick(contract.id)">
                        {{ $t('signedDocument') }}
                      </el-dropdown-item>
                      <el-dropdown-item @click.native="onDuplicateButtonClick(contract.id)">
                        {{ $t('duplicate') }}
                      </el-dropdown-item>
                      <el-dropdown-item @click.native="onDeleteButtonClick(contract)" class="text-error">
                        {{ $t('delete') }}
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <div v-if="getTotalSignedDocument(contract) > 0"
                     style="float: right; margin-right: 10px; margin-top: 10px; cursor: pointer"
                     @click="onTotalSignedDocumentClick(contract.id)">
                  <div class="font-primary"
                       style="float: left; font-size: 13px; margin-right: 3px; font-weight: 600">
                    {{ contract.totalSignedDocument }}
                  </div>
                  <div class="signed-document-primary"
                       style="float: left; margin-top: 3px"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <div style="margin-top: 10px">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="itemPerPage"
        :current-page="currentPage"
        @current-change="onPageChanges"
        :total="totalListLength">
      </el-pagination>
    </div>

    <el-dialog :title="$t('popUpSelectDocumentType')" :visible="isShowPopupSelectedDocumentType"
               @close="onClosePopupSelectDocumentType()" width="30%">
      <div style="text-align: center; margin: 10px;">
        <el-button type="primary" @click="onOpenPopupSendEmailButtonClick('docx')" plain>Microsoft Word (docx)
        </el-button>
        <el-button type="danger" @click="onOpenPopupSendEmailButtonClick('pdf')" plain>PDF</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="$t('popUpSelectDocumentType')" :visible="isShowPopupSelectedDocumentTypeDownload"
               @close="onClosePopupSelectDocumentTypeDownload()" width="30%">
      <div style="text-align: center; margin: 10px;">
        <el-button type="primary" @click="onDownloadButtonClick('docx')" plain>Microsoft Word (docx)</el-button>
        <el-button type="danger" @click="onDownloadButtonClick('pdf')" plain>PDF</el-button>
      </div>
    </el-dialog>

    <popup-signed-document-list
      :visible="isShowPopupSignedDocumentList"
      :contract-id="showPopupSignedDocumentContractId"
      @onClose="isShowPopupSignedDocumentList = false"
      @onUploaded="onUploadedSignedDocument"
    ></popup-signed-document-list>
  </div>
</template>

<script>
import i18nMessages from '@/translations/Contract/List.i18n'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import NotificationMixin from '@/mixins/notification-mixin'
import _, { get } from 'lodash'
import { CONTRACT_STATUS, STATUS } from '@/configs/constant'
import { updateContractStatus } from '@/services/contract-service'
import ContractApi from '@/api/contract-api'
import { dateFormat } from '@/helpers/datetime'
import PopupSignedDocumentList from '@/views/Contract/components/PopupSignedDocumentList'

export default {
  name: 'ContractListComponent',
  components: { PopupSignedDocumentList },
  mixins: [AlertViewMixin, LoadingViewMixin, NotificationMixin],
  i18n: { messages: i18nMessages },
  model: {
    prop: 'contractList',
    event: 'onChangeStatus'
  },
  props: {
    contractList: {
      type: Array,
      default: () => {
        return []
      }
    },
    hotelList: {
      type: Array,
      default: () => {
        return []
      }
    },
    agentList: {
      type: Array,
      default: () => {
        return []
      }
    },
    marketList: {
      type: Array,
      default: () => {
        return []
      }
    },
    salePersonList: {
      type: Array,
      default: () => {
        return []
      }
    },
    isShowFromAgent: {
      type: Boolean,
      default: false
    },
    disabledNext: {
      type: Boolean,
      default: false
    },
    disabledPrevious: {
      type: Boolean,
      default: false
    },
    itemPerPage: {
      type: Number,
      default: 10
    },
    totalListLength: {
      type: Number,
      default: 1
    },
    currentPage: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      dateFormat,
      CONTRACT_STATUS,
      downloadContractDetail: {
        type: Object,
        default: () => {
          return {
            id: '',
            hotel: {},
            refCode: '',
            startDate: '',
            endDate: '',
            salePerson: {},
            contactPerson: {},
            internalNote: '',
            agent: {},
            status: 1,
            rateCodeList: [],
            promotionList: [],
            supplementList: [],
            transferList: [],
            termOfPayment: {
              dataList: []
            },
            termAndCondition: {
              dataList: []
            }
          }
        }
      },
      downloadSupplementTypeList: [],
      downloadCompanyData: {
        type: Object,
        default: () => {
          return {
            id: '',
            name: '',
            code: '',
            companyType: 1,
            currency: 'THB',
            isEnable: STATUS.ENABLE
          }
        }
      },
      downloadHotelData: {
        type: Object,
        default: () => {
          return {
            companyId: '',
            id: '',
            name: '',
            remark: '',
            information: {},
            isEnable: STATUS.ENABLE
          }
        }
      },
      isShowPopupSignedDocumentList: false,
      isShowPopupSelectedDocumentType: false,
      isShowPopupSelectedDocumentTypeDownload: false,
      selectedDocumentTypeContractId: '',
      showPopupSignedDocumentContractId: ''
    }
  },
  computed: {},
  methods: {

    getRowClassName: function (contract) {
      return (contract.status === CONTRACT_STATUS.DRAFT) ? 'bg-contract-draft' : ''
    },
    getTextClassName: function (contract) {
      return (contract.status === CONTRACT_STATUS.DRAFT) ? 'text-contract-draft' : ''
    },
    isShowInternalNote: function (contract) {
      const internalNote = get(contract, 'internalNote', '')
      return (internalNote.trim() !== '')
    },
    getStatusType: function (status) {
      return (status === CONTRACT_STATUS.PUBLISHED) ? 'success' : 'info'
    },
    onChangeStatus: async function (contractId, status) {
      try {
        this.startLoading()

        await updateContractStatus(contractId, status)
        const newContractList = this.contractList.map((item) => {
          if (item.id === contractId) {
            item.status = status
          }

          return item
        })
        this.$emit('onChangeStatus', newContractList)

        const notificationTitle = this.$t('updateContractStatusSuccess')
        this.showNotificationSuccess(notificationTitle)
      } catch (err) {
        this.alertError(err.message)
      }

      this.stopLoading()
    },
    getStatusName: function (status) {
      let statusName = ''

      switch (status) {
        case CONTRACT_STATUS.DRAFT:
          statusName = this.$t('draft')
          break
        case CONTRACT_STATUS.PUBLISHED:
          statusName = this.$t('published')
          break
        default:
          statusName = 'N/A'
          break
      }

      return statusName
    },
    getHotelName: function (hotelId) {
      const hotelData = this.hotelList.find(hotel => hotel.id === hotelId)
      const hotelName = get(hotelData, 'name', '-')

      return hotelName
    },
    getContractValid: function (contractData) {
      let contractValid = '-'
      const filterData = _.omitBy(contractData, _.isNull)
      const contractStart = get(filterData, 'startDate', undefined)
      const contractEnd = get(filterData, 'endDate', undefined)

      if (contractStart !== undefined && contractEnd !== undefined) {
        const startDate = new Date(contractStart)
        const endDate = new Date(contractEnd)

        contractValid = `${dateFormat.short(startDate)} - ${dateFormat.short(endDate)}`
      }

      return contractValid
    },
    onEditButtonClick: function (row) {
      const hotelData = this.hotelList.find(hotel => hotel.id === row.hotelId)

      return this.$router.push({
        name: 'ContractEdit',
        params: {
          contractId: row.id,
          hotel: hotelData,
          agentList: this.agentList,
          salePersonList: this.salePersonList,
          isShowFromAgent: this.isShowFromAgent
        }
      })
    },
    onDeleteButtonClick: async function (row) {
      const confirmMessage = this.$t('confirmRemoveContractMessage', {
        refCode: row.refCode
      })
      const confirmButtonText = this.$t('confirmButtonText')
      const cancelButtonText = this.$t('cancelButtonText')
      const isConfirmRemove = await this.alertConfirmDelete(confirmMessage, confirmButtonText, cancelButtonText)

      if (!isConfirmRemove) {
        return false
      }

      this.removeContract(row.id)
    },
    removeContract: async function (contractId) {
      try {
        this.startLoading()

        await ContractApi.remove(contractId)
        this.$emit('onRemovedContract', contractId)

        const notificationTitle = this.$t('removeContractSuccess')
        this.showNotificationSuccess(notificationTitle)
      } catch (err) {
        this.alertError(err.message)
      }

      this.stopLoading()
    },
    onDownloadButtonClick: async function (fileType) {
      const data = {
        contractId: this.selectedDocumentTypeContractId,
        fileType: fileType
      }

      this.onClosePopupSelectDocumentTypeDownload()
      this.$emit('onDownloadButtonClick', data)
    },
    onPreviewButtonClick: async function (contractId) {
      this.$emit('onPreviewButtonClick', contractId)
    },
    onOpenPopupSelectDocumentType: function (contractId) {
      this.selectedDocumentTypeContractId = contractId
      this.isShowPopupSelectedDocumentType = true
    },
    onOpenPopupSelectDocumentTypeDownload: function (contractId) {
      this.selectedDocumentTypeContractId = contractId
      this.isShowPopupSelectedDocumentTypeDownload = true
    },
    onOpenPopupSendEmailButtonClick: async function (fileType) {
      const data = {
        contractId: this.selectedDocumentTypeContractId,
        fileType: fileType
      }

      this.onClosePopupSelectDocumentType()
      this.$emit('onOpenPopupSendEmailButtonClick', data)
    },
    onClosePopupSelectDocumentType: function () {
      this.selectedDocumentTypeContractId = ''
      this.isShowPopupSelectedDocumentType = false
    },
    onClosePopupSelectDocumentTypeDownload: function () {
      this.selectedDocumentTypeContractId = ''
      this.isShowPopupSelectedDocumentTypeDownload = false
    },
    onDuplicateButtonClick: async function (contractId) {
      this.$emit('onDuplicateButtonClick', contractId)
    },
    onPageChanges: function (page) {
      this.$emit('onPageChange', page)
    },
    getMarketList: function (agentId) {
      const marketList = this.marketList.filter((item) => {
        const agentIdList = item.agentIdList
        if (agentIdList.includes(agentId)) {
          return true
        }
        return false
      })

      return marketList
    },
    getAgentName: function (contractItem) {
      const agentName = get(contractItem, 'agentName', '-')

      return agentName
    },
    getSalePersonName: function (contractItem) {
      const salePersonName = get(contractItem, 'salePersonName', '')

      return (salePersonName.trim() === '') ? '-' : salePersonName.trim()
    },
    getTotalSignedDocument: function (contractItem) {
      const totalSignedDocument = get(contractItem, 'totalSignedDocument', 0)

      return totalSignedDocument
    },
    onTotalSignedDocumentClick: function (contractId) {
      this._showPopupSignedDocumentList(contractId)
    },
    onSignedDocumentClick: function (contractId) {
      this._showPopupSignedDocumentList(contractId)
    },
    onUploadedSignedDocument: function (contractId) {
      this.contractList.forEach((contract) => {
        if (contract.id === contractId) {
          if (contract.totalSignedDocument === undefined) {
            contract.totalSignedDocument = 1
          } else {
            contract.totalSignedDocument += 1
          }
        }
      })
    },
    _showPopupSignedDocumentList: function (contractId) {
      this.isShowPopupSignedDocumentList = true
      this.showPopupSignedDocumentContractId = contractId
    }
  }
}
</script>

<style scoped>
#contract-list-table {
  width: 100%;
  border: 1px solid #dddddd;
  border-radius: 5px;
  box-shadow: 0px 3px 5px 1px #eeeeee;
}

.ul-table {
  margin: 0;
  border-left: 1px solid #ddd;
  border-top: 1px solid #ddd;
  border-right: 1px solid #ddd;
  padding: 10px;
}

.ul-table > li {
  list-style: none;
  margin: 10px;
}

.ul-table:last-child {
  border-bottom: 1px solid #ddd;
}

.row-table {
  display: inline-block;
  width: 20%;
  vertical-align: top;
}

.inline-block {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
}

.form-contract-data {
  padding: 0 10px;
}

.border-contract-ref-code {
  background-color: #ecf5ff;
  color: #2f7dfe;
  padding: 6px 10px;
  border-radius: 5px;
  font-size: 12px;
  font-weight: 600;
  text-overflow: ellipsis;
  overflow: hidden;
}

.btn-icon-note {
  font-size: 22px;
  position: relative;
  top: 3px;
  padding: 0 5px;
  color: #909399;
  cursor: pointer;
}

.internal-note-popover-header {
  padding: 10px;
  border-bottom: 1px solid #EBEEF5;
  font-size: 15px;
  background-color: #f8f9fa;
}

.internal-note-popover-body {
  padding: 10px;
}

.label-contract-row {
  font-size: 12px;
  color: #909399;
  font-weight: 600;
}

.data-contract-row {
  font-size: 14px;
  color: #666666;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.bg-contract-draft {
  background-color: #f5f7fa;
}

.text-contract-draft {
  opacity: 0.5;
}

.el-button {
  text-align: left;
}

.el-button--info .el-icon--right {
  margin-left: 32px;
}

.el-button--success .el-icon--right {
  /*margin-left: 11px;*/
}

.text-error {
  color: #F56C6C;
}

.el-dropdown-menu {
  padding: 0;
}

.action-list .el-dropdown-menu__item.text-error {
  color: #F56C6C;
}

.action-list .el-dropdown-menu__item {
  color: #409EFF;
  background: #ecf5ff;
  border-color: #b3d8ff;
  border-bottom: 1px #fff solid;
  padding: 0 70px 0 20px;
}

.action-list .el-dropdown-menu__item:hover {
  color: #FFF;
  background-color: #409EFF;
  border-color: #409EFF;
}

.action-list .el-dropdown-menu__item:last-of-type {
  border-bottom: 0;
}

.el-button--success {
  color: #FFF;
  background-color: #48c195;
  border-color: #48c195;
}

.el-button--success:focus, .el-button--success:hover {
  background: #5adaac;
  border-color: #5adaac;
  color: #FFF;
}

.el-tag.el-tag--warning {
  font-weight: bold !important;
  border-color: #e6a23c !important;
}

.total-signed-document {
  margin-top: 10px;
  padding-left: 5px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
}
</style>
